import React from "react";

export const PopupContext = React.createContext();